import Component from '@glimmer/component';
import type { CaseStudySignature } from 'tpk-website/data/case-studies';
import { caseStudies } from 'tpk-website/data/case-studies';

interface PagesBaseWeDoArgs {}

export default class PagesBaseWeDoComponent extends Component<PagesBaseWeDoArgs> {
  arrayOfCaseStudies: CaseStudySignature[] = caseStudies;
  caseStudies = this.arrayOfCaseStudies.reverse().slice(0, 3);
}
